export const generateQueryId = (): bigint => {
  return BigInt(Date.now())
}